import angular from "angular";
import template from "./admin-edit-instructor-certifications.html";
import AdminInstructorsEditCertificationsController from "./admin-edit-instructor-certifications.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.instructors.edit.certifications", {
    url: "/credentials",
    controller: AdminInstructorsEditCertificationsController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.instructors.edit.certifications", [])
  .config(config)
  .controller(
    "AdminInstructorsEditCertificationsController",
    AdminInstructorsEditCertificationsController,
  );
